import {
    getStore
} from '@/utils/store'
import website from '@/config/website'

const state = {
    language: getStore({
        name: 'language'
    }) || 'zh',
    loginVisible: false, // 登录框状态
    pulseLoader: false, // 加载动画状态
    isRefresh: false, //控制刷新状态
    isCollapse: false,
    isFullScren: false,
    isShade: false,
    screen: -1,
    isLock: getStore({ name: 'isLock' }) || false,
    showTag: true,
    showDebug: true,
    showCollapse: true,
    showSearch: true,
    showLock: true,
    showFullScren: true,
    showTheme: true,
    showMenu: true,
    showColor: true,
    colorName: getStore({ name: 'colorName' }) || '#00aafa',
    themeName: getStore({ name: 'themeName' }) || 'theme-default',
    lockPasswd: getStore({ name: 'lockPasswd' }) || '',
    website: website,
    curExp: getStore({ name: 'retainExp' }) || null, // 正在进行的实验
    questionTypeList: [] // 题型列表
}

export default state